import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { showToast } from "src/utils/toaster/showToast";

import { useDeleteRewardEntryInLedgerMutation } from "src/services/RewardService";
import DeleteReatilerRewardForm from "./DeleteReatilerRewardForm";

export type DeleteReatilerRewardFormValues = {
  otp: string;
};

type Props = {
  onClose: () => void;
  entryId: string;
  deleteAmount:string ;
};

const DeleteReatilerRewardFormWrapper = ({ onClose, entryId ,deleteAmount }: Props) => {
    const [deleteReward] = useDeleteRewardEntryInLedgerMutation()

  // Form Initial Values
  const initialValues: DeleteReatilerRewardFormValues = {
    otp: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    otp: string().required("Please enter otp"),
  });

  // Handle Submit
  const handleSubmit = (
    values: DeleteReatilerRewardFormValues,
    { setSubmitting, resetForm }: FormikHelpers<DeleteReatilerRewardFormValues>
  ) => {
    deleteReward({ id: entryId, body: values }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <DeleteReatilerRewardForm
              formikProps={formikProps}
              onClose={onClose}
              deleteAmount={deleteAmount}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default DeleteReatilerRewardFormWrapper;
